import React, { useState, useCallback, useRef, useEffect } from "react";
import ReactCanvasConfetti from "react-canvas-confetti";
import type { CreateTypes } from "canvas-confetti";

interface ConfettiProps {
  duration?: number;
  onComplete?: () => void;
  particleCount?: number;
  spread?: number;
}

export const Confetti: React.FC<ConfettiProps> = ({
  duration = 3000,
  onComplete,
  particleCount = 100,
  spread = 70,
}) => {
  const [isAnimating, setIsAnimating] = useState(true);
  const confettiRef = useRef<CreateTypes | null>(null);

  const getInstance = useCallback((instance: CreateTypes | null) => {
    confettiRef.current = instance;
  }, []);

  const makeShot = useCallback(() => {
    if (confettiRef.current) {
      confettiRef.current({
        particleCount,
        spread,
        origin: { y: 0.6, x: 0.5 },
        colors: [
          "#0070F3", // primary blue
          "#38A1FF", // light blue
          "#10B981", // emerald green
          "#FBBF24", // amber
          "#D946EF", // magenta (accent)
        ],
      });
    }
  }, [particleCount, spread]);

  useEffect(() => {
    if (isAnimating) {
      const interval = setInterval(makeShot, 300);
      const timer = setTimeout(() => {
        clearInterval(interval);
        setIsAnimating(false);
        if (onComplete) {
          onComplete();
        }
      }, duration);

      return () => {
        clearInterval(interval);
        clearTimeout(timer);
      };
    }
  }, [isAnimating, makeShot, duration, onComplete]);

  return (
    <ReactCanvasConfetti
      // @ts-expect-error - ReactCanvasConfetti has incompatible refConfetti type but works at runtime
      refConfetti={getInstance}
      style={{
        position: "fixed",
        pointerEvents: "none",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        zIndex: 100,
      }}
    />
  );
};
